const rankings = [
  { rank: 1, title: '某顶流男星深夜密会视频曝光，女方身份引猜测', heat: '🔥 1286万', tag: '爆', change: 'up' },
  { rank: 2, title: '知名综艺节目录制现场突发事故，导演组被曝处理不当', heat: '🔥 963万', tag: '热', change: 'up' },
  { rank: 3, title: '网红圈又出大瓜！千万粉丝博主被曝虚假人设', heat: '🔥 871万', tag: '热', change: 'new' },
  { rank: 4, title: '某国际大牌代言人深陷丑闻，品牌方紧急解约', heat: '752万', tag: '热', change: 'up' },
  { rank: 5, title: '选秀节目投票黑幕曝光，前工作人员实名举报', heat: '689万', tag: '', change: 'down' },
  { rank: 6, title: '娱乐圈某对模范夫妻被曝早已分居，财产分割引关注', heat: '621万', tag: '', change: 'new' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-bold mb-4">
            <i className="ri-bar-chart-2-line"></i>
            热度榜单
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-3">
            吃瓜热度排行榜
          </h2>
          <p className="text-foreground-500 text-sm">实时更新，今日最受关注的八卦爆料 TOP 6</p>
        </div>

        <div className="space-y-3">
          {rankings.map((item) => (
            <a
              key={item.rank}
              href="#ranking"
              className="flex items-center gap-4 bg-background-100 rounded-xl p-4 hover:shadow-md transition-all duration-200 group"
            >
              <div className={`flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-xl font-black text-lg ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-bold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
              </div>
              <div className="flex-shrink-0 flex items-center gap-2">
                {item.tag && (
                  <span className={`text-xs px-2 py-0.5 rounded-full font-bold whitespace-nowrap ${
                    item.tag === '爆' ? 'bg-primary-500 text-background-50' : 'bg-accent-100 text-accent-700'
                  }`}>
                    {item.tag}
                  </span>
                )}
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}</span>
                <span className="text-xs">
                  {item.change === 'up' && <i className="ri-arrow-up-line text-green-500"></i>}
                  {item.change === 'down' && <i className="ri-arrow-down-line text-red-400"></i>}
                  {item.change === 'new' && <span className="text-accent-500 font-bold">NEW</span>}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}